import React, { FC } from "react";
import { TitleProps } from "antd/es/typography/Title";

import * as Styled from "./styles";

const Title: FC<TitleProps> = (props) => <Styled.Title {...props} />;

export default Title;
